/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
  var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
  if (api && typeof api.t === 'function') return api.t(key, params);
  if (typeof module === 'object' && module.exports && typeof require === 'function') {
    var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
    var dict = require('../json/i18n/' + lang + '/js-runtime.json');
    var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
    return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
  }
  return key;
}

/* SZKIC ZESTAWU (Fala 2 „Obserwowane liczby", 29.09.2026).
 *
 * Jeden biezacy szkic dla kazdej z pieciu gier: Lotto i Lotto Plus (6 z 49),
 * Mini Lotto (5 z 42), Multi Multi (cel 1-10 z 80), Eurojackpot (5 z 50 + 2 z 12).
 * Kaskada i Keno nie maja szkicu. Magazyn: localStorage pewniaki:szkic-zestawu:v1
 * — osobny od pewniaki:moje-zestawy:v2 (gotowe zestawy) i
 * pewniaki:obserwowane-liczby:v1 (obserwacje); ich formatow nie dotyka.
 *
 * Format magazynu (v1):
 *   { v: 1, gry: { <kod>: { liczby: [int], dodatkowe: [int], cel: int,
 *                            zapisany: { id, nazwa, sig } | null } } }
 *   `liczby` rosnaco, bez duplikatow, z puli glownej; `dodatkowe` tylko dla
 *   Eurojackpot (pula 1-12); `cel` tylko dla Multi Multi (1-10, domyslnie 10);
 *   `zapisany` = ostatni zapis tego dokladnie szkicu w Moich kuponach (id zestawu,
 *   nazwa, sygnatura liczb) — pozwala pokazac stan „zapisano” i przejscia po
 *   odswiezeniu. Kazda zmiana czyta biezacy stan, zmienia i zapisuje z kontrola;
 *   nieudany zapis zostawia magazyn bez zmian i nie zglasza sukcesu.
 *
 * Trzy warstwy w jednym pliku:
 *   1. Magazyn — window.PewniakiSzkic (wczytaj, lista, zawiera, dodaj, usun,
 *      przelacz, wyczysc, ustawCel, oznaczZapis). Po kazdej udanej zmianie
 *      zdarzenie DOM `pewniaki:szkic-zmiana` {detail: {gra}}; zmiana w innej
 *      karcie (storage) jest przekazywana tym samym zdarzeniem.
 *   2. Panel [data-szk-panel] (layout/_szkic-zestawu.html.twig): licznik,
 *      wybrane liczby, usuwanie, „Wyczysc” z cofnieciem (tylko w biezacym widoku,
 *      i tylko gdy szkic nie zmienil sie od czyszczenia — takze w innej karcie),
 *      cel Multi Multi, liczby Euro, zapis przez window.PewniakiZestawy.sklep()
 *      .dodaj(kod, {liczby, dodatkowe, nazwa}, 'analizator') i przejscie do
 *      sprawdzarki/analizatora przez PewniakiZestawy.zapiszPrzekaz() + adres
 *      narzedzia z atrybutow panelu (te same, co skrot „Moje kupony”).
 *   3. Adaptery widokow — przycisk „Do zestawu / W zestawie” przy liczbie:
 *      tabela czestotliwosci [data-czestotliwosc-tabela], zaleglosci
 *      [data-zaleglosci-tabela], rekordy przerw [data-rekordy-przerw-tabela],
 *      partnerzy [data-pp-list] (strona analizy), partnerzy profilu
 *      [data-profil-partnerzy], panel obserwowanych (wiersz szczegolow
 *      [data-obs-szczegoly]) i przycisk profilu [data-szk-profil]. Adapter
 *      dopisuje kolumne/przycisk, obserwuje tbody (MutationObserver) — po
 *      zmianie zakresu, sortowaniu czy przerysowaniu przyciski wracaja bez
 *      drugiego listenera (jeden delegowany `click` na tabele, znacznik startu).
 *      Zadnego globalnego przechwytywania kulek: dziala tylko wlasny przycisk.
 *
 * Teksty: <script type="application/json" data-szk-teksty> z
 * layout/_szkic-teksty.html.twig (assets/json/i18n/{pl,en}/szkic-zestawu.json).
 * Liczby prywatne nie ida do analityki ani do adresu; przekazanie do narzedzia
 * niesie tylko kod gry i id zapisanego zestawu (istniejacy mechanizm 6A).
 * Test: node ai/test-szkic-zestawu-dom.js */
(function (root, doc) {
    'use strict';
    if (!doc || root.PewniakiSzkic) { return; }

    var KLUCZ = 'pewniaki:szkic-zestawu:v1';
    var WERSJA = 1;
    var ZDARZENIE = 'pewniaki:szkic-zmiana';
    var ZRODLO_ZAPISU = 'analizator';
    var GRY = Object.assign(Object.create(null), {
        'lotto':       { pula: 49, cele: [6],  celDomyslny: 6,  dodatkowe: null },
        'lotto-plus':  { pula: 49, cele: [6],  celDomyslny: 6,  dodatkowe: null },
        'mini-lotto':  { pula: 42, cele: [5],  celDomyslny: 5,  dodatkowe: null },
        'multi-multi': { pula: 80, cele: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], celDomyslny: 10, dodatkowe: null },
        'eurojackpot': { pula: 50, cele: [5],  celDomyslny: 5,  dodatkowe: { pula: 12, ile: 2 } }
    });

    /* ------------------------------------------------------------- teksty --- */
    var TEKSTY = null;
    function teksty() {
        if (TEKSTY) { return TEKSTY; }
        var el = doc.querySelector('script[type="application/json"][data-szk-teksty]');
        try { TEKSTY = el ? JSON.parse(el.textContent) : {}; } catch (e) { TEKSTY = {}; }
        return TEKSTY;
    }
    function t(klucz, p) {
        var s = teksty()[klucz];
        if (typeof s !== 'string') { return klucz; }
        return s.replace(/\$\{([A-Za-z_][A-Za-z0-9_]*)\}/g, function (_, k) { return p && p[k] !== undefined ? String(p[k]) : ''; });
    }
    function en() { return /^en(?:-|$)/i.test(doc.documentElement.lang || ''); }
    /** Przyrostek odmiany: _1 (1), _2 (2-4 poza 12-14), _5 (reszta); EN: _1 / _2. */
    function odmiana(n) {
        if (en()) { return n === 1 ? '_1' : '_2'; }
        if (n === 1) { return '_1'; }
        var r = n % 10, r100 = n % 100;
        return (r >= 2 && r <= 4 && !(r100 >= 12 && r100 <= 14)) ? '_2' : '_5';
    }
    function el(tag, klasa, tekst) {
        var e = doc.createElement(tag);
        if (klasa) { e.className = klasa; }
        if (tekst !== undefined && tekst !== null) { e.textContent = String(tekst); }
        return e;
    }
    function calkowita(v) { var n = Number(v); return Number.isInteger(n) ? n : NaN; }
    function rosnaco(a, b) { return a - b; }
    function sygnatura(w) { return w.liczby.join(',') + '|' + w.dodatkowe.join(','); }

    /* ------------------------------------------------------------ magazyn --- */
    function pusty() { return { v: WERSJA, gry: {} }; }
    function pustyWpis(kod) { return { liczby: [], dodatkowe: [], cel: GRY[kod].celDomyslny, zapisany: null }; }
    function listaZ(wej, pula, max) {
        if (!Array.isArray(wej)) { return []; }
        var out = [], byla = {};
        for (var i = 0; i < wej.length && out.length < max; i++) {
            var n = calkowita(wej[i]);
            if (!(n >= 1 && n <= pula) || byla[n]) { continue; }
            byla[n] = true; out.push(n);
        }
        return out.sort(rosnaco);
    }
    /** Niezaufane dane -> poprawny stan; zly ksztalt calego dokumentu = uszkodzony. */
    function oczysc(surowe) {
        var d = null;
        try { d = JSON.parse(surowe); } catch (e) { return null; }
        if (!d || typeof d !== 'object' || Array.isArray(d) || d.v !== WERSJA || !d.gry || typeof d.gry !== 'object' || Array.isArray(d.gry)) { return null; }
        var s = pusty();
        Object.keys(d.gry).forEach(function (kod) {
            var g = GRY[kod], w = d.gry[kod];
            if (!g || !w || typeof w !== 'object') { return; }
            var o = pustyWpis(kod);
            // Wiecej liczb niz najwiekszy cel nie jest mozliwe, ale bez ciecia do
            // biezacego celu: cel Multi Multi obnizony nie ma usuwac liczb po cichu.
            o.liczby = listaZ(w.liczby, g.pula, g.cele[g.cele.length - 1]);
            o.dodatkowe = g.dodatkowe ? listaZ(w.dodatkowe, g.dodatkowe.pula, g.dodatkowe.ile) : [];
            var c = calkowita(w.cel);
            o.cel = g.cele.indexOf(c) >= 0 ? c : g.celDomyslny;
            if (w.zapisany && typeof w.zapisany === 'object' && typeof w.zapisany.id === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(w.zapisany.id) && typeof w.zapisany.sig === 'string') {
                o.zapisany = { id: w.zapisany.id, nazwa: typeof w.zapisany.nazwa === 'string' ? w.zapisany.nazwa.slice(0, 60) : '', sig: w.zapisany.sig.slice(0, 200) };
            }
            if (o.liczby.length || o.dodatkowe.length || o.cel !== g.celDomyslny || o.zapisany) { s.gry[kod] = o; }
        });
        return s;
    }
    /** Odczyt bez zapisu: {stan, dostepny, uszkodzony}. */
    function wczytaj() {
        var surowe = null;
        try { surowe = root.localStorage.getItem(KLUCZ); }
        catch (e) { return { stan: pusty(), dostepny: false, uszkodzony: false }; }
        if (surowe === null || surowe === undefined) { return { stan: pusty(), dostepny: true, uszkodzony: false }; }
        var s = oczysc(surowe);
        return { stan: s || pusty(), dostepny: true, uszkodzony: !s };
    }
    function zapisz(stan) {
        var tekst = JSON.stringify(stan);
        try {
            root.localStorage.setItem(KLUCZ, tekst);
            return root.localStorage.getItem(KLUCZ) === tekst;
        } catch (e) { return false; }
    }
    function oglos(kod) {
        if (typeof root.CustomEvent !== 'function') { return; }
        try { doc.dispatchEvent(new root.CustomEvent(ZDARZENIE, { detail: { gra: kod } })); } catch (e) { /* stary silnik */ }
    }
    /** Biezacy stan -> fn(wpis, stan) -> zapis z kontrola. fn zwraca null (ok) albo {ok:false,...}. */
    function zmien(kod, fn) {
        if (!GRY[kod]) { return { ok: false, powod: 'gra' }; }
        var w = wczytaj();
        if (!w.dostepny) { return { ok: false, powod: 'pamiec' }; }
        var s = w.stan, wpis = s.gry[kod] || pustyWpis(kod);
        var r = fn(wpis, s);
        if (r && r.ok === false) { return r; }
        if (wpis.liczby.length || wpis.dodatkowe.length || wpis.cel !== GRY[kod].celDomyslny || wpis.zapisany) { s.gry[kod] = wpis; }
        else { delete s.gry[kod]; }
        if (!zapisz(s)) { return { ok: false, powod: 'zapis' }; }
        oglos(kod);
        return { ok: true, wpis: kopiaWpisu(wpis) };
    }
    function kopiaWpisu(w) { return { liczby: w.liczby.slice(), dodatkowe: w.dodatkowe.slice(), cel: w.cel, zapisany: w.zapisany ? { id: w.zapisany.id, nazwa: w.zapisany.nazwa, sig: w.zapisany.sig } : null }; }
    function wpisGry(kod) { var w = wczytaj(); return kopiaWpisu(w.stan.gry[kod] || pustyWpis(kod)); }
    function pulaOk(kod, pula) { return pula === 'dodatkowa' ? !!GRY[kod].dodatkowe : pula === 'glowna' || pula === undefined; }
    function limitPuli(kod, wpis, pula) { return pula === 'dodatkowa' ? GRY[kod].dodatkowe.ile : wpis.cel; }
    function maxPuli(kod, pula) { return pula === 'dodatkowa' ? GRY[kod].dodatkowe.pula : GRY[kod].pula; }
    function tablica(wpis, pula) { return pula === 'dodatkowa' ? wpis.dodatkowe : wpis.liczby; }

    var Magazyn = {
        KLUCZ: KLUCZ, WERSJA: WERSJA, ZDARZENIE: ZDARZENIE,
        gry: function () { return Object.keys(GRY); },
        reguly: function (kod) { return GRY[kod] ? JSON.parse(JSON.stringify(GRY[kod])) : null; },
        wczytaj: wczytaj,
        wpis: wpisGry,
        lista: function (kod, pula) { var w = wpisGry(kod); return pula === 'dodatkowa' ? w.dodatkowe : w.liczby; },
        zawiera: function (kod, n, pula) { return GRY[kod] ? tablica(wpisGry(kod), pula).indexOf(n) >= 0 : false; },
        dodaj: function (kod, n, pula) {
            if (!GRY[kod] || !pulaOk(kod, pula)) { return { ok: false, powod: 'gra' }; }
            n = calkowita(n);
            if (!(n >= 1 && n <= maxPuli(kod, pula))) { return { ok: false, powod: 'liczba' }; }
            return zmien(kod, function (wpis) {
                var l = tablica(wpis, pula);
                if (l.indexOf(n) >= 0) { return { ok: false, powod: 'juz' }; }
                if (l.length >= limitPuli(kod, wpis, pula)) { return { ok: false, powod: 'limit', limit: limitPuli(kod, wpis, pula) }; }
                l.push(n); l.sort(rosnaco);
                return null;
            });
        },
        usun: function (kod, n, pula) {
            if (!GRY[kod] || !pulaOk(kod, pula)) { return { ok: false, powod: 'gra' }; }
            n = calkowita(n);
            return zmien(kod, function (wpis) {
                var l = tablica(wpis, pula), i = l.indexOf(n);
                if (i < 0) { return { ok: false, powod: 'brak' }; }
                l.splice(i, 1);
                return null;
            });
        },
        przelacz: function (kod, n, pula) {
            return Magazyn.zawiera(kod, calkowita(n), pula) ? Magazyn.usun(kod, n, pula) : Magazyn.dodaj(kod, n, pula);
        },
        /** Świadome zastąpienie głównych liczb jednej gry. Jeden zapis, bez
            częściowego dodawania i bez naruszenia szkiców innych gier/Euroliczb. */
        ustawLiczby: function (kod, liczby, cel) {
            var g = GRY[kod];
            if (!g || !Array.isArray(liczby)) { return { ok: false, powod: 'gra' }; }
            var w = wpisGry(kod), c = cel === undefined ? w.cel : calkowita(cel);
            if (g.cele.indexOf(c) < 0) { return { ok: false, powod: 'cel' }; }
            if (liczby.length > c) { return { ok: false, powod: 'limit', limit: c }; }
            var ns = listaZ(liczby, g.pula, c);
            if (ns.length !== liczby.length || !liczby.every(function (n) { return typeof n === 'number' && Number.isInteger(n); })) { return { ok: false, powod: 'liczba' }; }
            return zmien(kod, function (wpis) { wpis.liczby = ns; wpis.cel = c; return null; });
        },
        /** Czysci liczby obu pul i znacznik zapisu; cel Multi Multi zostaje. Zwraca poprzedni wpis do cofniecia. */
        wyczysc: function (kod) {
            var przed = null;
            var r = zmien(kod, function (wpis) { przed = kopiaWpisu(wpis); wpis.liczby = []; wpis.dodatkowe = []; wpis.zapisany = null; return null; });
            if (r.ok) { r.poprzedni = przed; }
            return r;
        },
        /** Przywraca wpis TYLKO gdy biezacy stan gry nadal rowna sie `oczekiwany` (stan po czyszczeniu). */
        przywroc: function (kod, wpis, oczekiwanySig) {
            if (!GRY[kod] || !wpis) { return { ok: false, powod: 'gra' }; }
            return zmien(kod, function (biezacy) {
                if (sygnaturaWpisu(biezacy) !== oczekiwanySig) { return { ok: false, powod: 'konflikt' }; }
                var g = GRY[kod];
                biezacy.liczby = listaZ(wpis.liczby, g.pula, g.cele[g.cele.length - 1]);
                biezacy.dodatkowe = g.dodatkowe ? listaZ(wpis.dodatkowe, g.dodatkowe.pula, g.dodatkowe.ile) : [];
                biezacy.cel = g.cele.indexOf(wpis.cel) >= 0 ? wpis.cel : g.celDomyslny;
                biezacy.zapisany = wpis.zapisany ? { id: wpis.zapisany.id, nazwa: wpis.zapisany.nazwa, sig: wpis.zapisany.sig } : null;
                return null;
            });
        },
        ustawCel: function (kod, cel) {
            cel = calkowita(cel);
            if (!GRY[kod] || GRY[kod].cele.indexOf(cel) < 0) { return { ok: false, powod: 'cel' }; }
            return zmien(kod, function (wpis) { wpis.cel = cel; return null; });
        },
        oznaczZapis: function (kod, id, nazwa) {
            return zmien(kod, function (wpis) { wpis.zapisany = { id: String(id), nazwa: String(nazwa || '').slice(0, 60), sig: sygnatura(wpis) }; return null; });
        },
        /** Czego brakuje do kompletnego szkicu: {kompletny, brakGlowne, brakDodatkowe, nadmiar}. */
        ocen: function (kod) {
            var g = GRY[kod]; if (!g) { return null; }
            var w = wpisGry(kod);
            var brak = Math.max(0, w.cel - w.liczby.length), nadmiar = Math.max(0, w.liczby.length - w.cel);
            var brakD = g.dodatkowe ? Math.max(0, g.dodatkowe.ile - w.dodatkowe.length) : 0;
            return { kompletny: brak === 0 && nadmiar === 0 && brakD === 0, brakGlowne: brak, brakDodatkowe: brakD, nadmiar: nadmiar, cel: w.cel, wpis: w };
        },
        sygnatura: sygnatura,
        /* Fala 3 (30.09.2026): import kopii. Cala mapa gier naraz po scislej walidacji
           (zamknieta lista gier, liczby w pulach, bez duplikatow, limity celu, Multi Multi
           1-10, Eurojackpot do 2 Euro, bez Kaskady); `zapisany` NIE jest przenoszony —
           id kuponu z innego urzadzenia moze wskazywac inny zestaw. Odrzucenie = zero zapisu. */
        sprawdzImport: function (gry) {
            if (!gry || typeof gry !== 'object' || Array.isArray(gry)) { return { ok: false, powod: 'format' }; }
            var s = pusty(), klucze = Object.keys(gry), ile = 0;
            for (var i = 0; i < klucze.length; i++) {
                var kod = klucze[i], g = GRY[kod], w = gry[kod];
                if (!g || !w || typeof w !== 'object' || Array.isArray(w)) { return { ok: false, powod: 'format', gra: kod }; }
                var pola = Object.keys(w);
                for (var j = 0; j < pola.length; j++) { if (['liczby', 'dodatkowe', 'cel'].indexOf(pola[j]) < 0) { return { ok: false, powod: 'format', gra: kod }; } }
                var o = pustyWpis(kod);
                if (w.liczby !== undefined) {
                    if (!Array.isArray(w.liczby) || w.liczby.length > g.cele[g.cele.length - 1] || !w.liczby.every(function (n) { return typeof n === 'number' && Number.isInteger(n); })) { return { ok: false, powod: 'format', gra: kod }; }
                    var l = listaZ(w.liczby, g.pula, g.cele[g.cele.length - 1]);
                    if (l.length !== w.liczby.length) { return { ok: false, powod: 'format', gra: kod }; }
                    o.liczby = l;
                }
                if (w.dodatkowe !== undefined && !(Array.isArray(w.dodatkowe) && w.dodatkowe.length === 0)) {
                    if (!g.dodatkowe || !Array.isArray(w.dodatkowe) || w.dodatkowe.length > g.dodatkowe.ile || !w.dodatkowe.every(function (n) { return typeof n === 'number' && Number.isInteger(n); })) { return { ok: false, powod: 'format', gra: kod }; }
                    var d = listaZ(w.dodatkowe, g.dodatkowe.pula, g.dodatkowe.ile);
                    if (d.length !== w.dodatkowe.length) { return { ok: false, powod: 'format', gra: kod }; }
                    o.dodatkowe = d;
                }
                if (w.cel !== undefined) {
                    if (typeof w.cel !== 'number' || !Number.isInteger(w.cel)) { return { ok: false, powod: 'format', gra: kod }; }
                    var c = calkowita(w.cel);
                    if (g.cele.indexOf(c) < 0) { return { ok: false, powod: 'format', gra: kod }; }
                    o.cel = c;
                }
                if (o.liczby.length || o.dodatkowe.length || o.cel !== g.celDomyslny) { s.gry[kod] = o; ile += o.liczby.length + o.dodatkowe.length; }
            }
            return { ok: true, stan: s, liczb: ile };
        },
        zastap: function (gry) {
            var w = Magazyn.sprawdzImport(gry);
            if (!w.ok) { return w; }
            var m = wczytaj();
            if (!m.dostepny) { return { ok: false, powod: 'pamiec' }; }
            if (!zapisz(w.stan)) { return { ok: false, powod: 'zapis' }; }
            oglos(null);
            return { ok: true, liczb: w.liczb };
        },
        /** Czyszczenie szkicow wszystkich gier — tylko ten klucz. */
        wyczyscWszystko: function () {
            var m = wczytaj();
            if (!m.dostepny) { return { ok: false, powod: 'pamiec' }; }
            try { root.localStorage.removeItem(KLUCZ); if (root.localStorage.getItem(KLUCZ) !== null) { return { ok: false, powod: 'zapis' }; } }
            catch (e) { return { ok: false, powod: 'zapis' }; }
            oglos(null);
            return { ok: true };
        },
        /** Eksport: liczby, dodatkowe i cel kazdej gry — bez `zapisany`. */
        eksport: function () {
            var w = wczytaj(), out = {};
            Object.keys(w.stan.gry).forEach(function (kod) { var g = w.stan.gry[kod]; out[kod] = { liczby: g.liczby.slice(), dodatkowe: g.dodatkowe.slice(), cel: g.cel }; });
            return out;
        }
    };
    function sygnaturaWpisu(w) { return sygnatura(w) + '|' + w.cel + '|' + (w.zapisany ? w.zapisany.id : ''); }
    root.PewniakiSzkic = Magazyn;

    // Zmiana w innej karcie tej samej przegladarki -> to samo zdarzenie strony.
    root.addEventListener('storage', function (e) {
        if (e.key === KLUCZ || e.key === null) { oglos(null); }
    });

    function MZ() { return root.PewniakiZestawy || null; }
    function sklep() { var m = MZ(); try { return m && typeof m.sklep === 'function' ? m.sklep() : null; } catch (e) { return null; } }
    function kolorKuli(kod) { return kod === 'eurojackpot' ? ' kula--eurojackpot' : ' kula--' + kod; }
    function kula(kod, n, dodatkowa) {
        var k = el('span', "kula kula--mala" + (dodatkowa ? ' kula--specjalna' : kolorKuli(kod)), n);
        k.setAttribute('aria-hidden', 'true');
        return k;
    }

    /* -------------------------------------------------------------- panel --- */
    function panel(box) {
        if (box.getAttribute('data-szk-start') === '1') { return; }
        box.setAttribute('data-szk-start', '1');
        var kod = box.getAttribute('data-gra'), g = GRY[kod];
        if (!g) { return; }
        var nazwaGry = box.getAttribute('data-nazwa') || kod;
        var q = function (s) { return box.querySelector(s); };
        var licznik = q('[data-szk-licznik]'), liczbyUl = q('[data-szk-liczby]'), pustoEl = q('[data-szk-pusto]');
        var wybor = q('[data-szk-wybor]'), dodajBtn = q('[data-szk-dodaj]');
        var dodUl = q('[data-szk-dodatkowe]'), wyborD = q('[data-szk-wybor-dodatkowa]'), dodajD = q('[data-szk-dodaj-dodatkowa]'), licznikD = q('[data-szk-licznik-dodatkowe]');
        var celSel = q('[data-szk-cel]'), braki = q('[data-szk-braki]'), status = q('[data-szk-status]');
        var nazwa = q('[data-szk-nazwa]'), zapiszBtn = q('[data-szk-zapisz]'), wyczyscBtn = q('[data-szk-wyczysc]'), cofnijBtn = q('[data-szk-cofnij]');
        var zapisanoBox = q('[data-szk-zapisano]'), zapisanoTekst = q('[data-szk-zapisano-tekst]'), sprawdzBtn = q('[data-szk-sprawdz]'), analizujBtn = q('[data-szk-analizuj]');
        var adresSprawdzarki = (box.getAttribute('data-szk-sprawdzarka') || '').split('?')[0];
        var adresAnalizatora = box.getAttribute('data-szk-analizator') || '';
        var cofniecie = null;      // { wpis, sig } — tylko w tym widoku
        var zapisywanie = false;
        var ostatniStatusBlad = false;

        function komunikat(tekst, blad) {
            status.textContent = tekst || '';
            status.className = blad ? 'blad-pola' : 'podpowiedz';
            ostatniStatusBlad = !!blad;
        }
        function tekstBledu(r, n, pula) {
            if (r.powod === 'juz') { return t('already', { n: n }); }
            if (r.powod === 'limit') { return pula === 'dodatkowa' ? t('limit_extra', { n: n }) : t('limit', { n: n, cel: r.limit }); }
            if (r.powod === 'liczba') { return t('bad_number', { n: n }); }
            if (r.powod === 'pamiec') { return t('storage_off'); }
            return t('save_failed');
        }
        function chip(n, pula) {
            var li = el('li', 'szkic__liczba');
            li.setAttribute('data-szk-wybrana', String(n));
            if (pula === 'dodatkowa') { li.setAttribute('data-szk-pula', 'dodatkowa'); }
            li.appendChild(kula(kod, n, pula === 'dodatkowa'));
            li.appendChild(el('span', 'sr-only', String(n)));
            var b = el('button', 'szkic__usun');
            b.type = 'button';
            b.setAttribute('aria-label', t(pula === 'dodatkowa' ? 'remove_extra_aria' : 'remove_aria', { n: n }));
            b.setAttribute('data-szk-usun', String(n));
            b.setAttribute('data-szk-pula', pula);
            var ikonaUsun = wyczyscBtn.querySelector('.ikona');
            if (ikonaUsun) { b.appendChild(ikonaUsun.cloneNode(true)); }
            li.appendChild(b);
            return li;
        }
        function ocenaTekst(o) {
            if (o.nadmiar > 0) { return t('too_many', { d: o.nadmiar, cel: o.cel }); }
            var czesci = [];
            if (o.brakGlowne > 0) { czesci.push(t('missing_main' + odmiana(o.brakGlowne), { n: o.brakGlowne })); }
            if (o.brakDodatkowe > 0) { czesci.push(t('missing_extra' + odmiana(o.brakDodatkowe), { n: o.brakDodatkowe })); }
            return czesci.length ? czesci.join(' ') : t('ready');
        }
        function zapisanyNadalIstnieje(z) {
            var S = sklep();
            if (!S) { return true; }                          // bez modulu nie da sie sprawdzic — nie chowamy
            try {
                return S.lista(kod).some(function (x) {
                    return x.id === z.id && sygnatura({ liczby: x.numbers, dodatkowe: x.extra || [] }) === z.sig;
                });
            } catch (e) { return false; }
        }
        function odswiez() {
            var w = wczytaj(), wpis = w.stan.gry[kod] || pustyWpis(kod);
            var o = Magazyn.ocen(kod);
            var nad = wpis.liczby.length > wpis.cel;
            var opisLicznika = nad ? t('count_over', { n: wpis.liczby.length, cel: wpis.cel, d: wpis.liczby.length - wpis.cel }) : t('count', { n: wpis.liczby.length, cel: wpis.cel });
            licznik.textContent = wpis.liczby.length + ' / ' + wpis.cel;
            licznik.setAttribute('aria-label', opisLicznika);
            licznik.setAttribute('title', opisLicznika);
            licznik.setAttribute('data-szk-n', String(wpis.liczby.length));
            licznik.setAttribute('data-szk-cel-n', String(wpis.cel));
            while (liczbyUl.firstChild) { liczbyUl.removeChild(liczbyUl.firstChild); }
            wpis.liczby.forEach(function (n) { liczbyUl.appendChild(chip(n, 'glowna')); });
            pustoEl.hidden = wpis.liczby.length > 0 || wpis.dodatkowe.length > 0;
            liczbyUl.hidden = !wpis.liczby.length;
            if (dodUl) {
                while (dodUl.firstChild) { dodUl.removeChild(dodUl.firstChild); }
                wpis.dodatkowe.forEach(function (n) { dodUl.appendChild(chip(n, 'dodatkowa')); });
                dodUl.hidden = !wpis.dodatkowe.length;
                if (licznikD) { licznikD.textContent = t('count_extra', { n: wpis.dodatkowe.length, cel: g.dodatkowe.ile }); }
            }
            if (celSel && String(celSel.value) !== String(wpis.cel)) { celSel.value = String(wpis.cel); }
            // Wybor domyslny: pierwsza wolna liczba (bez nadpisywania recznego wyboru zajetego).
            if (wybor && wpis.liczby.indexOf(calkowita(wybor.value)) >= 0) {
                for (var i = 0; i < wybor.options.length; i++) { if (wpis.liczby.indexOf(calkowita(wybor.options[i].value)) < 0) { wybor.value = wybor.options[i].value; break; } }
            }
            braki.textContent = (wpis.liczby.length || wpis.dodatkowe.length) ? ocenaTekst(o) : '';
            braki.setAttribute('data-szk-kompletny', o.kompletny ? '1' : '0');
            var zapisany = wpis.zapisany && wpis.zapisany.sig === sygnatura(wpis) && zapisanyNadalIstnieje(wpis.zapisany) ? wpis.zapisany : null;
            zapisanoBox.hidden = !zapisany;
            if (zapisany) {
                zapisanoTekst.textContent = t('saved_state', { nazwa: zapisany.nazwa });
                zapisanoBox.setAttribute('data-szk-zapisany-id', zapisany.id);
                sprawdzBtn.hidden = !adresSprawdzarki;
                var S = sklep(), m = MZ(), r = S ? S.reguly(kod) : null;
                var doAn = !!(adresAnalizatora && r && m && typeof m.doAnalizatora === 'function' && m.doAnalizatora(r, { numbers: wpis.liczby }));
                analizujBtn.hidden = !doAn;
            } else { zapisanoBox.removeAttribute('data-szk-zapisany-id'); }
            zapiszBtn.disabled = !o.kompletny || !!zapisany || zapisywanie || !w.dostepny;
            wyczyscBtn.disabled = !(wpis.liczby.length || wpis.dodatkowe.length) || !w.dostepny;
            if (dodajBtn) { dodajBtn.disabled = !w.dostepny; }
            if (dodajD) { dodajD.disabled = !w.dostepny; }
            if (celSel) { celSel.disabled = !w.dostepny; }
            if (!w.dostepny) { komunikat(t('storage_off'), true); }
            else if (w.uszkodzony && !status.textContent) { komunikat(t('storage_bad'), false); }
            // Cofniecie zostaje dostepne tylko, gdy stan po czyszczeniu sie nie zmienil.
            if (cofniecie && sygnaturaWpisu(wpis) !== cofniecie.sig) { cofniecie = null; }
            cofnijBtn.hidden = !cofniecie;
        }
        function poZmianie(r, n, pula, dodano) {
            if (!r.ok) { komunikat(tekstBledu(r, n, pula), true); return; }
            cofniecie = null;
            var w = r.wpis;
            komunikat(t(dodano ? 'added' : 'removed', { n: n, k: (pula === 'dodatkowa' ? w.dodatkowe : w.liczby).length, cel: pula === 'dodatkowa' ? g.dodatkowe.ile : w.cel }), false);
        }
        if (dodajBtn) {
            dodajBtn.addEventListener('click', function () {
                var n = calkowita(wybor.value);
                poZmianie(Magazyn.dodaj(kod, n, 'glowna'), n, 'glowna', true);
                odswiez();
            });
        }
        if (dodajD) {
            dodajD.addEventListener('click', function () {
                var n = calkowita(wyborD.value);
                poZmianie(Magazyn.dodaj(kod, n, 'dodatkowa'), n, 'dodatkowa', true);
                odswiez();
            });
        }
        box.addEventListener('click', function (e) {
            var b = e.target.closest ? e.target.closest('[data-szk-usun]') : null;
            if (!b || !box.contains(b)) { return; }
            var n = calkowita(b.getAttribute('data-szk-usun')), pula = b.getAttribute('data-szk-pula') || 'glowna';
            var li = b.closest('li'), nast = li && li.nextElementSibling ? li.nextElementSibling : (li && li.previousElementSibling);
            var nastN = nast ? nast.getAttribute('data-szk-wybrana') : null;
            poZmianie(Magazyn.usun(kod, n, pula), n, pula, false);
            odswiez();
            var cel = nastN ? box.querySelector('[data-szk-usun="' + nastN + '"][data-szk-pula="' + pula + '"]') : null;
            (cel || (pula === 'dodatkowa' ? dodajD : dodajBtn) || wyczyscBtn).focus();
        });
        if (celSel) {
            celSel.addEventListener('change', function () {
                var r = Magazyn.ustawCel(kod, calkowita(celSel.value));
                if (!r.ok) { komunikat(tekstBledu(r), true); }
                else { cofniecie = null; komunikat('', false); }
                odswiez();
            });
        }
        wyczyscBtn.addEventListener('click', function () {
            var r = Magazyn.wyczysc(kod);
            if (!r.ok) { komunikat(tekstBledu(r), true); odswiez(); return; }
            var p = r.poprzedni, ile = p.liczby.length + p.dodatkowe.length;
            cofniecie = { wpis: p, sig: sygnaturaWpisu(r.wpis) };
            komunikat(t('cleared', { n: p.liczby.concat(p.dodatkowe.length ? [jst("fragment.288bbc3d4d5361ce") + p.dodatkowe.join(', ')] : []).join(', ') || ile }), false);
            odswiez();
            cofnijBtn.focus();
        });
        cofnijBtn.addEventListener('click', function () {
            if (!cofniecie) { return; }
            var r = Magazyn.przywroc(kod, cofniecie.wpis, cofniecie.sig);
            cofniecie = null;
            if (!r.ok) { komunikat(r.powod === 'konflikt' ? t('undo_conflict') : tekstBledu(r), true); }
            else { komunikat(t('undone'), false); }
            odswiez();
            wyczyscBtn.focus();
        });
        zapiszBtn.addEventListener('click', function () {
            if (zapisywanie) { return; }
            var o = Magazyn.ocen(kod);
            if (!o.kompletny) { komunikat(ocenaTekst(o), true); return; }
            var S = sklep();
            if (!S) { komunikat(t('save_module'), true); return; }
            var r = S.reguly(kod);
            if (!r) { komunikat(t('save_module'), true); return; }
            zapisywanie = true; zapiszBtn.disabled = true; zapiszBtn.setAttribute('aria-busy', 'true');
            var tekstZapisz = zapiszBtn.querySelector('[data-szk-zapisz-tekst]') || zapiszBtn;
            var poprzedniTekst = tekstZapisz.textContent; tekstZapisz.textContent = t('saving');
            var wynik;
            try { wynik = S.dodaj(kod, { liczby: o.wpis.liczby, dodatkowe: o.wpis.dodatkowe, nazwa: nazwa ? nazwa.value : '' }, ZRODLO_ZAPISU); }
            catch (e) { wynik = { ok: false, blad: 'wyjatek' }; }
            zapisywanie = false; zapiszBtn.removeAttribute('aria-busy'); tekstZapisz.textContent = poprzedniTekst;
            if (!wynik || !wynik.ok || !wynik.zestaw) {
                var b = wynik ? wynik.blad : 'wyjatek';
                var mapa = { duplikat: 'save_dup', limit: 'save_limit', niedostepny: 'save_storage', miejsce: 'save_space', liczby: 'save_rules', ile: 'save_rules', niepoprawny: 'save_rules', dodatkowe: 'save_rules', gra: 'save_module' };
                komunikat(t(mapa[b] || 'save_module', { max: MZ() && MZ().LIMIT || 20 }), true);
                odswiez();
                return;
            }
            try { S.zdarzenie('my_ticket_save', kod, ZRODLO_ZAPISU, wynik.liczba); } catch (e) { /* analityka nie blokuje zapisu */ }
            var oz = Magazyn.oznaczZapis(kod, wynik.zestaw.id, wynik.zestaw.name);
            komunikat(t('saved', { nazwa: wynik.zestaw.name, k: wynik.liczba, max: MZ() && MZ().LIMIT || 20 }), false);
            if (nazwa) { nazwa.value = ''; }
            cofniecie = null;
            odswiez();
            if (!oz.ok) { zapisanoBox.hidden = false; zapisanoTekst.textContent = t('saved_state', { nazwa: wynik.zestaw.name }); zapisanoBox.setAttribute('data-szk-zapisany-id', wynik.zestaw.id); sprawdzBtn.hidden = !adresSprawdzarki; }
            sprawdzBtn.focus();
        });
        function doNarzedzia(cel, adres) {
            var id = zapisanoBox.getAttribute('data-szk-zapisany-id'), m = MZ();
            if (!id || !adres || !m || typeof m.zapiszPrzekaz !== 'function') { return; }
            m.zapiszPrzekaz(cel, kod, id);                           // tylko kod gry i id — bez liczb
            root.location.assign(adres);
        }
        sprawdzBtn.addEventListener('click', function () { doNarzedzia('sprawdzarka', adresSprawdzarki + '?gra=' + encodeURIComponent(kod)); });
        analizujBtn.addEventListener('click', function () { doNarzedzia('analiza', adresAnalizatora); });
        doc.addEventListener(ZDARZENIE, function () { odswiez(); });
        doc.addEventListener('pewniaki:zestawy-gotowe', function () { odswiez(); });
        doc.addEventListener('pewniaki:zestawy-zmiana', function () { odswiez(); });
        box.hidden = false;
        odswiez();
    }

    /* ----------------------------------------------------- adaptery widokow --- */
    function przyciskPrzelacznika(kod, n) {
        var b = el('button', "przycisk przycisk--drugi szkic-przycisk");
        b.type = 'button';
        b.setAttribute('data-szk-przelacz', String(n));
        b.setAttribute('data-gra', kod);
        b.setAttribute('aria-pressed', 'false');
        ustawStan(b, false);
        return b;
    }
    function ustawStan(b, jest) {
        var n = b.getAttribute('data-szk-przelacz');
        b.setAttribute('aria-pressed', jest ? 'true' : 'false');
        var tekst = jest ? t('toggle_in') : t('toggle_add');
        if (b.textContent !== tekst) { b.textContent = tekst; }
        b.setAttribute('aria-label', jest ? t('toggle_in_aria', { n: n }) : t('toggle_add_aria', { n: n }));
    }
    function odswiezPrzyciski(kod) {
        var lista = Magazyn.lista(kod, 'glowna');
        Array.prototype.forEach.call(doc.querySelectorAll('[data-szk-przelacz][data-gra="' + kod + '"]'), function (b) {
            ustawStan(b, lista.indexOf(calkowita(b.getAttribute('data-szk-przelacz'))) >= 0);
        });
        var skrot = doc.querySelector('[data-szk-skrot]');
        if (skrot) {
            var w = wpisGry(kod), tekst = t('shortcut', { n: w.liczby.length, cel: w.cel });
            if (skrot.textContent !== tekst) { skrot.textContent = tekst; }
        }
    }
    /** Wspolna obsluga klikniecia przycisku (delegacja z korzenia widoku). */
    function obsluzKlik(e, kod, status) {
        var b = e.target.closest ? e.target.closest('[data-szk-przelacz]') : null;
        if (!b || b.getAttribute('data-gra') !== kod) { return; }
        var n = calkowita(b.getAttribute('data-szk-przelacz'));
        var jest = b.getAttribute('aria-pressed') === 'true';
        var r = jest ? Magazyn.usun(kod, n, 'glowna') : Magazyn.dodaj(kod, n, 'glowna');
        if (status) {
            if (r.ok) { status.textContent = t(jest ? 'removed' : 'added', { n: n, k: r.wpis.liczby.length, cel: r.wpis.cel }); status.className = 'podpowiedz'; }
            else { status.textContent = r.powod === 'juz' ? t('already', { n: n }) : r.powod === 'limit' ? t('limit', { n: n, cel: r.limit }) : r.powod === 'pamiec' ? t('storage_off') : r.powod === 'brak' ? t('removed', { n: n, k: wpisGry(kod).liczby.length, cel: wpisGry(kod).cel }) : t('save_failed'); status.className = 'blad-pola'; }
        }
        odswiezPrzyciski(kod);
    }
    function statusWidoku(korzen) {
        var s = korzen.querySelector('[data-szk-status-widoku]');
        if (!s) { s = el('p', "podpowiedz szkic-status"); s.setAttribute('data-szk-status-widoku', ''); s.setAttribute('role', 'status'); s.setAttribute('aria-live', 'polite'); }
        return s;
    }
    function skrotDoPanelu(przed, kod) {
        if (!doc.getElementById('szkic-zestawu') || doc.querySelector('[data-szk-skrot]') || !przed || !przed.parentNode) { return; }
        var p = el('p', "tekst-maly szkic-skrot");
        var a = el('a', 'link-akcja');
        a.href = '#szkic-zestawu'; a.setAttribute('data-szk-skrot', ''); a.setAttribute('aria-label', t('shortcut_aria'));
        var w = wpisGry(kod); a.textContent = t('shortcut', { n: w.liczby.length, cel: w.cel });
        p.appendChild(a);
        przed.parentNode.insertBefore(p, przed);
    }
    function numerZWiersza(tr, cfg) {
        if (cfg.atrybut && tr.hasAttribute(cfg.atrybut)) { return calkowita(tr.getAttribute(cfg.atrybut)); }
        var c = tr.cells && tr.cells[0];
        if (!c) { return NaN; }
        if (c.hasAttribute('data-sort')) { return calkowita(c.getAttribute('data-sort')); }
        var k = c.querySelector('.kula');
        return calkowita(k ? k.textContent.trim() : c.textContent.trim());
    }
    /** Tabela: kolumna „Zestaw” z przyciskiem w kazdym wierszu; odporna na przerysowanie tbody. */
    function tabela(tab, kod, cfg) {
        if (tab.getAttribute('data-szk-start') === '1') { return; }
        tab.setAttribute('data-szk-start', '1');
        var pula = GRY[kod].pula;
        var status = statusWidoku(tab.closest('section') || tab.parentNode);
        // Komunikat i skrot stoja POZA siatka tabel (partnerzy: .siatka--3), inaczej
        // stalyby sie kolejnymi polami siatki.
        var otoczka = tab.closest('.siatka') || tab.closest('.tabela-scroll') || tab;
        if (!status.parentNode) { otoczka.parentNode.insertBefore(status, otoczka.nextSibling); }
        function dekoruj() {
            var head = tab.tHead && tab.tHead.rows[0];
            if (head && !head.querySelector('[data-szk-kol]')) {
                var th = el('th', null, t('col_set'));
                th.setAttribute('scope', 'col'); th.setAttribute('data-szk-kol', '');
                head.appendChild(th);
            }
            Array.prototype.forEach.call(tab.tBodies, function (body) {
                Array.prototype.forEach.call(body.rows, function (tr) {
                    if (tr.querySelector('[data-szk-kom]') || (cfg.pomin && tr.matches(cfg.pomin))) { return; }
                    var n = numerZWiersza(tr, cfg);
                    var td = el('td', 'szkic-komorka');
                    td.setAttribute('data-szk-kom', '');
                    if (n >= 1 && n <= pula) { td.appendChild(przyciskPrzelacznika(kod, n)); }
                    tr.appendChild(td);
                });
            });
            odswiezPrzyciski(kod);
        }
        var zaplanowane = false;
        function zaplanuj() {
            if (zaplanowane) { return; }
            zaplanowane = true;
            root.requestAnimationFrame(function () { zaplanowane = false; dekoruj(); });
        }
        new MutationObserver(function (zmiany) {
            for (var i = 0; i < zmiany.length; i++) {
                if (zmiany[i].addedNodes.length) { zaplanuj(); return; }
            }
        }).observe(tab, { childList: true, subtree: true });
        tab.addEventListener('click', function (e) { obsluzKlik(e, kod, status); });
        dekoruj();
        skrotDoPanelu(otoczka, kod);
    }
    /** Panel obserwowanych: przycisk w wierszu szczegolow (obok „Usun”). */
    function obserwowane(box) {
        if (box.getAttribute('data-szk-start') === '1') { return; }
        var kod = box.getAttribute('data-gra');
        if (!GRY[kod]) { return; }
        box.setAttribute('data-szk-start', '1');
        var wiersze = box.querySelector('[data-obs-wiersze]');
        if (!wiersze) { return; }
        var status = statusWidoku(box);
        var ramka = box.querySelector('[data-obs-tabela-ramka]');
        if (!status.parentNode && ramka) { ramka.parentNode.insertBefore(status, ramka.nextSibling); }
        function dekoruj() {
            Array.prototype.forEach.call(wiersze.querySelectorAll('tr[data-obs-szczegoly]'), function (tr) {
                if (tr.querySelector('[data-szk-przelacz]')) { return; }
                var n = calkowita(tr.getAttribute('data-obs-szczegoly')), akcje = tr.querySelector('.przyciski-rzad');
                if (!akcje || !(n >= 1 && n <= GRY[kod].pula)) { return; }
                var usun = akcje.querySelector('[data-obs-usun]');
                akcje.insertBefore(przyciskPrzelacznika(kod, n), usun || null);
            });
            odswiezPrzyciski(kod);
        }
        var zaplanowane = false;
        new MutationObserver(function () {
            if (zaplanowane) { return; }
            zaplanowane = true;
            root.requestAnimationFrame(function () { zaplanowane = false; dekoruj(); });
        }).observe(wiersze, { childList: true });
        box.addEventListener('click', function (e) { obsluzKlik(e, kod, status); });
        dekoruj();
        if (ramka) { skrotDoPanelu(ramka, kod); }
    }
    /** Profil liczby: przycisk obok „Obserwuj”. */
    function profil(box) {
        if (box.getAttribute('data-szk-start') === '1') { return; }
        var kod = box.getAttribute('data-gra'), n = calkowita(box.getAttribute('data-liczba'));
        if (!GRY[kod] || !(n >= 1 && n <= GRY[kod].pula)) { return; }
        box.setAttribute('data-szk-start', '1');
        var b = box.querySelector('[data-szk-przelacz]');
        if (!b) { b = przyciskPrzelacznika(kod, n); box.insertBefore(b, box.firstChild); }
        else { b.setAttribute('data-szk-przelacz', String(n)); b.setAttribute('data-gra', kod); }
        var status = box.querySelector('[data-szk-profil-status]') || statusWidoku(box);
        if (!status.parentNode) { box.appendChild(status); }
        var skrot = box.querySelector('[data-szk-skrot]');
        box.addEventListener('click', function (e) { obsluzKlik(e, kod, status); });
        odswiezPrzyciski(kod);
        box.hidden = false;
        if (skrot) { var w = wpisGry(kod); skrot.textContent = t('shortcut', { n: w.liczby.length, cel: w.cel }); }
    }

    function start() {
        Array.prototype.forEach.call(doc.querySelectorAll('[data-szk-panel]'), panel);
        var panelBox = doc.querySelector('[data-szk-panel]');
        var kod = panelBox ? panelBox.getAttribute('data-gra') : null;
        if (!kod || !GRY[kod]) { return; }
        var strona = doc.querySelector('[data-analiza-strona]');
        var kodStrony = strona ? strona.getAttribute('data-gra') : null;
        if (!kodStrony || kodStrony === kod) {
            Array.prototype.forEach.call(doc.querySelectorAll('[data-czestotliwosc-tabela]'), function (x) { tabela(x, kod, {}); });
            Array.prototype.forEach.call(doc.querySelectorAll('[data-zaleglosci-tabela], [data-rekordy-przerw-tabela]'), function (x) { tabela(x, kod, {}); });
            Array.prototype.forEach.call(doc.querySelectorAll('[data-pp-root="partnerzy"]'), function (root2) {
                Array.prototype.forEach.call(root2.querySelectorAll('table[data-pp-list]'), function (x) { tabela(x, kod, { atrybut: 'data-pp-row' }); });
                // Tabele partnerow moga powstac dopiero z JS (brak SSR) — dopinamy nowe.
                new MutationObserver(function () {
                    Array.prototype.forEach.call(root2.querySelectorAll('table[data-pp-list]:not([data-szk-start])'), function (x) { tabela(x, kod, { atrybut: 'data-pp-row' }); });
                }).observe(root2, { childList: true, subtree: true });
            });
        }
        Array.prototype.forEach.call(doc.querySelectorAll('[data-profil-partnerzy]'), function (x) { tabela(x, kod, {}); });
        Array.prototype.forEach.call(doc.querySelectorAll('[data-obs-panel]'), obserwowane);
        Array.prototype.forEach.call(doc.querySelectorAll('[data-szk-profil]'), profil);
        doc.addEventListener(ZDARZENIE, function () { odswiezPrzyciski(kod); });
    }
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); } else { start(); }
})(typeof window !== 'undefined' ? window : this, typeof document !== 'undefined' ? document : null);
